import { ReactNode } from "react";

interface IImageSlide {
  title?: string;
  children?: ReactNode;
  image: string;
}

export default function ImageSlide({ title, children, image }: IImageSlide) {
  return (
    <section data-background-image={image} className="image-slide">
      { (children || title) && <div className="overlay">
        {title && (
          <header>
            <h2>{title}</h2>
          </header>
        )}
        { children && <div className="slide-body">{children}</div>}
      </div>}
    </section>
  );
}
